import React from 'react'
import { Input } from 'semantic-ui-react';
import PropTypes from "prop-types";

const TextInput = ({onChange,...rest}) => {
    return <Input onChange={(e, {value})=>onChange(value)} {...rest} />
}
TextInput.propTypes = {
    onChange: PropTypes.func
}
export default TextInput;